import { keys } from "./Keys";
import { RestError } from "../../services/rest-service/RestService";
import { BaseUseQueryParameters } from "../BaseUseQueryParameters";
import { ISummaryDTO, ISummarySearchDTO } from "../../services/setpoint-administration-service/Models";
import SetpointAdministrationDataService from "../../services/setpoint-administration-service/SetpointAdministrationService";
import { useQuery } from "react-query";

export type UseSetpointDataParams = {
    groupID: number,
    searchCriteria: ISummarySearchDTO,
} & BaseUseQueryParameters<ISummaryDTO | undefined>;

export function useSetpointData({
    groupID,
    searchCriteria,
    enabled,    
    onSuccess,
    onError
}: UseSetpointDataParams) {
    return useQuery<ISummaryDTO, RestError>(
        keys.setPoints(groupID, 
            searchCriteria,
        ),
        ({ signal }) => {
            return SetpointAdministrationDataService.getSetpoints(
                groupID, 
                searchCriteria,
                signal
            );
        },
        {
            enabled,
            onError: onError,
            onSuccess: onSuccess,
            //refetchInterval: refreshSeconds ? refreshSeconds * 1000 : false,
            refetchInterval: false,
            refetchOnMount: true
        }
    );
}